import { isArray, isString } from './type-guards.js';

const parse = (urlPath)=>{
    const urlParams = new URLSearchParams(urlPath);
    const queryParams = {};
    for (const [key, value] of urlParams.entries()){
        const existingValue = queryParams[key];
        if (existingValue) {
            if (isArray(existingValue)) {
                existingValue.push(value);
            } else {
                queryParams[key] = [
                    existingValue,
                    value
                ];
            }
        } else {
            queryParams[key] = value;
        }
    }
    return queryParams;
};
const stringify = (params, noQuestionMark = false, decode = false)=>{
    if (!params) return '';
    const mappedQueryParams = {};
    for (const [key, value] of Object.entries(params)){
        if (isArray(value)) {
            mappedQueryParams[key] = value.join(',');
        } else if (isString(value)) {
            mappedQueryParams[key] = value;
        }
    }
    const urlParams = new URLSearchParams(mappedQueryParams);
    let paramsString = urlParams.toString();
    if (!noQuestionMark) {
        paramsString = `?${paramsString}`;
    }
    if (decode) {
        paramsString = decodeURIComponent(paramsString);
    }
    return paramsString;
};

export { parse, stringify };
//# sourceMappingURL=query.js.map
